<form [formGroup]="assignEfPanelForm" #formRef="ngForm">
  <div class="dialog-title">Assign End Financier</div>

  <mat-form-field>
    <mat-label>Select End Financier</mat-label>
    <mat-select formControlName="selectedFinancier" (selectionChange)="onFinancierChange($event.value)" required>
      <mat-option *ngFor="let financier of financierList" [value]="financier.id">{{ financier.name }}</mat-option>
    </mat-select>
    <mat-error>End Financier is required</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Select End Financier Contact</mat-label>
    <mat-select formControlName="selectedContacts" multiple required>
      <mat-option *ngFor="let contact of contactList" [value]="contact.id">{{ contact.name }}</mat-option>
    </mat-select>
    <mat-error>End Financier Contact is required</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!financierID">
    <input matInput currencyMask placeholder="Financial Limit" formControlName="financial_limit" required />
    <mat-error *ngIf="assignEfPanelForm.controls.financial_limit?.errors?.required">
      Financial limit is required
    </mat-error>
    <mat-error *ngIf="assignEfPanelForm.controls.financial_limit?.errors?.min">
      Financial limit min is 1</mat-error>
  </mat-form-field>


  <mat-form-field *ngIf="!financierID">
    <input matInput  [(ngModel)]="value" currencyMask placeholder="Interest Rate" formControlName="interest_rate"/>
    <mat-error *ngIf="assignEfPanelForm.controls.interest_rate?.errors?.max">
      Interest Rate max is 100
    </mat-error>
  </mat-form-field>

  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
    <button mat-button color="primary" (click)="assignPanel(assignEfPanelForm)">Assign</button>
  </div>
</form>